import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarIcon } from '@heroicons/react/24/outline';

const FloatingBookButton: React.FC = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/quick-book')}
      className="fixed bottom-6 right-6 bg-blue-500 hover:bg-blue-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-50"
      title="Reservar cita rápida"
    >
      <CalendarIcon className="w-6 h-6" />
    </button>
  );
};

export default FloatingBookButton;
